!function(){"use strict";
  const SECTION_SEL = "[data-section-type]";

  function getHandleFromLink(a){
    try{
      const url = new URL(a.href, location.origin);
      // espera /products/<handle>
      const parts = url.pathname.split("/").filter(Boolean);
      const idx = parts.indexOf("products");
      if(idx>=0 && parts[idx+1]) return parts[idx+1];
    }catch(e){}
    return null;
  }

  async function fetchProductTypeByHandle(handle){
    try{
      const res = await fetch(`/products/${handle}.js`, { credentials:"same-origin" });
      if(!res.ok) return "";
      const json = await res.json();
      return (json.product_type || json.type || "").toLowerCase().trim();
    }catch(e){ return ""; }
  }

  // Remove itens "Brinde" dentro de um wrapper (lista já renderizada)
  async function removeGiftCards(wrapper){
    if(!wrapper) return;
    // tente primeiro via data-attribute (se seu card tiver isso); senão, vai por fetch.
    const items = Array.from(wrapper.querySelectorAll('[data-product-card], .product-item, li, .grid__item'));
    // fallback: se não tiver cards com classes padrão, use links:
    const cards = items.length ? items : Array.from(wrapper.querySelectorAll('a[href*="/products/"]')).map(a => a.closest("a, li, div"));

    // coleta links únicos por card
    const links = [];
    cards.forEach(card=>{
      const a = card && card.querySelector ? card.querySelector('a[href*="/products/"]') : null;
      if(a) links.push({card, a});
    });

    // consulta tipos em paralelo e remove se for "brinde"
    await Promise.all(links.map(async ({card,a})=>{
      const handle = getHandleFromLink(a);
      if(!handle) return;
      const t = await fetchProductTypeByHandle(handle);
      if(t === "brinde"){
        card.remove();
      }
    }));
  }

  customElements.get("recently-viewed") || customElements.define("recently-viewed", class extends HTMLElement{
    constructor(){
      super();
      this.section = this.closest(SECTION_SEL);
      this.howManyToShow = parseInt(this.dataset.limit)||3;
      this.target = this.dataset.target;
      this.wrapperId = this.dataset.wrapperId || this.id;
    }
    connectedCallback(){
      Shopify.Products.showRecentlyViewed({
        howManyToShow: this.howManyToShow,
        wrapperId: this.wrapperId,
        section: this.section,
        target: this.target,
        onComplete: async () => {
          // depois que a lista for renderizada, filtra produtos do tipo "Brinde"
          const wrapper =
            (this.wrapperId && document.getElementById(this.wrapperId)) ||
            (this.target && document.querySelector(this.target)) ||
            this;
          await removeGiftCards(wrapper);

          // disparo original do tema
          this.dispatchEvent(new CustomEvent("theme:recently-viewed:loaded",{bubbles:!1}));
        }
      });
    }
  });
}();
